/*
 * UnitAccessibilityInfo Messages
 *
 * This contains all the text for the UnitAccessibilityInfo component.
 */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  ada: {
    id: 'App.UnitAccessibilityInfo.ada',
    defaultMessage: 'ADA',
  },
  accessibilityType: {
    id: 'App.UnitAccessibilityInfo.accessibilityType',
    defaultMessage: 'Accessibility Type',
  },
  yes: {
    id: 'App.UnitAccessibilityInfo.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'App.UnitAccessibilityInfo.no',
    defaultMessage: 'No',
  },
  adaYes: {
    id: 'App.UnitAccessibilityInfo.adaYes',
    defaultMessage: 'ADA: Yes',
  },
  adaNo: {
    id: 'App.UnitAccessibilityInfo.adaNo',
    defaultMessage: 'ADA: No',
  },
});

export default messages;
